import config from '../config';

function statusChangeCallback(response) {

    if (response.status === 'connected') {
        window.FBOauthResponse = response.authResponse;
        // Logged into your app and Facebook.
        // $.channel.emit('fbOauthSuccess' , response.authResponse);
    } else if (response.status === 'not_authorized') {
        // The person is logged into Facebook, but not your app.
        // document.getElementById('status').innerHTML = 'Please log ' +
        //   'into this app.';
        // FB.login(checkLoginState);
    } else {
        // The person is not logged into Facebook, so we're not sure if
        // they are logged into this app or not.
        // FB.login(checkLoginState);
    }
}

// This function is called when someone finishes with the Login
// Button.  See the onlogin handler attached to it in the sample
// code below.
window.checkLoginState = function() {
    FB.getLoginStatus(function(response) {
        statusChangeCallback(response);
    });
};

window.fbAsyncInit = function() {
    // alert('sdk')
    $.channel.emit('fbsdkLoaded');

    FB.init({
        appId      : config.upInfoInPlatform.fb.appid,
        cookie     : true,  // enable cookies to allow the server to access
        // the session
        xfbml      : true,  // parse social plugins on this page
        version    : 'v2.5' // use graph api version 2.5
    });

    // Now that we've initialized the JavaScript SDK, we call
    // FB.getLoginStatus().  This function gets the state of the
    // person visiting this page and can return one of three states to
    // the callback you provide.  They can be:
    //
    // 1. Logged into your app ('connected')
    // 2. Logged into Facebook, but not your app ('not_authorized')
    // 3. Not logged into Facebook and can't tell if they are logged into
    //    your app or not.
    //
    // These three cases are handled in the callback function.

    FB.getLoginStatus(function(response) {
        statusChangeCallback(response);
    });

};


function testAPI() {
    FB.api('/me', function(response) {
        console.log(response)
    });
}

let api = {
    init : function () {
        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    },
    checkLoginState : checkLoginState
};

export default api;



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/sns/fb.js